import { Component, inject, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { BackComponent } from '../../../../shared/components/back/back.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ContactFormComponent } from '../../../../shared/components/contact-form/contact-form.component';

interface FAQItem {
  question: string;
  answer: string;
  isOpen?: boolean;
}

interface TabCategory {
  id: string;
  label: string;
  faqs: FAQItem[];
}

@Component({
  selector: 'app-faqs',
  standalone: true,
  imports: [
    NgClass,
    BackComponent,
    TranslateModule,
    NgClass,
    ContactFormComponent,
  ],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.css',
})
export class FaqsComponent {
  private router = inject(Router);
  private translate = inject(TranslateService);

  activeTab = signal<string>('baggage');
  categories: TabCategory[] = [
    {
      id: 'baggage',
      label: 'Faqs.Baggage_Label',
      faqs: [
        {
          question: 'Faqs.Baggage_Q1',
          answer: 'Faqs.Baggage_A1',
          isOpen: true,
        },
        {
          question: 'Faqs.Baggage_Q2',
          answer: 'Faqs.Baggage_A2',
        },
        {
          question: 'Faqs.Baggage_Q3',
          answer: 'Faqs.Baggage_A3',
        },
        {
          question: 'Faqs.Baggage_Q4',
          answer: 'Faqs.Baggage_A4',
        },
      ],
    },
    {
      id: 'flight-booking',
      label: 'Faqs.Flight_Booking_Label',
      faqs: [
        {
          question: 'Faqs.Flight_Booking_Q1',
          answer: 'Faqs.Flight_Booking_A1',
        },
        {
          question: 'Faqs.Flight_Booking_Q2',
          answer: 'Faqs.Flight_Booking_A2',
        },
        {
          question: 'Faqs.Flight_Booking_Q3',
          answer: 'Faqs.Flight_Booking_A3',
        },
        {
          question: 'Faqs.Flight_Booking_Q4',
          answer: 'Faqs.Flight_Booking_A4',
        },
        {
          question: 'Faqs.Flight_Booking_Q5',
          answer: 'Faqs.Flight_Booking_A5',
        },
        {
          question: 'Faqs.Flight_Booking_Q6',
          answer: 'Faqs.Flight_Booking_A6',
        },
        {
          question: 'Faqs.Flight_Booking_Q7',
          answer: 'Faqs.Flight_Booking_A7',
        },
        {
          question: 'Faqs.Flight_Booking_Q8',
          answer: 'Faqs.Flight_Booking_A8',
        },
        {
          question: 'Faqs.Flight_Booking_Q9',
          answer: 'Faqs.Flight_Booking_A9',
        },
      ],
    },
    {
      id: 'Cancellations',
      label: 'Faqs.Cancellations_Label',
      faqs: [
        {
          question: 'Faqs.Cancellations_Q1',
          answer: 'Faqs.Cancellations_A1',
        },
        {
          question: 'Faqs.Cancellations_Q2',
          answer: 'Faqs.Cancellations_A2',
        },
        {
          question: 'Faqs.Cancellations_Q3',
          answer: 'Faqs.Cancellations_A3',
        },
        {
          question: 'Faqs.Cancellations_Q4',
          answer: 'Faqs.Cancellations_A4',
        },
        {
          question: 'Faqs.Cancellations_Q5',
          answer: 'Faqs.Cancellations_A5',
        },
      ],
    },
    {
      id: 'Confirmation',
      label: 'Faqs.Confirmation_Label',
      faqs: [
        {
          question: 'Faqs.Confirmation_Q1',
          answer: 'Faqs.Confirmation_A1',
        },
        {
          question: 'Faqs.Confirmation_Q2',
          answer: 'Faqs.Confirmation_A2',
        },
        {
          question: 'Faqs.Confirmation_Q3',
          answer: 'Faqs.Confirmation_A3',
        },
        {
          question: 'Faqs.Confirmation_Q4',
          answer: 'Faqs.Confirmation_A4',
        },
        {
          question: 'Faqs.Confirmation_Q5',
          answer: 'Faqs.Confirmation_A5',
        },
      ],
    },
    {
      id: 'payment',
      label: 'Faqs.Payment_Label',
      faqs: [
        {
          question: 'Faqs.Payment_Q1',
          answer: 'Faqs.Payment_A1',
        },
        {
          question: 'Faqs.Payment_Q2',
          answer: 'Faqs.Payment_A2',
        },
        {
          question: 'Faqs.Payment_Q3',
          answer: 'Faqs.Payment_A3',
        },
        {
          question: 'Faqs.Payment_Q4',
          answer: 'Faqs.Payment_A4',
        },
        {
          question: 'Faqs.Payment_Q5',
          answer: 'Faqs.Payment_A5',
        },
      ],
    },
    {
      id: 'traveler Information',
      label: 'Faqs.Traveler_Information_Label',
      faqs: [
        {
          question: 'Faqs.Traveler_Information_Q1',
          answer: 'Faqs.Traveler_Information_A1',
        },
        {
          question: 'Faqs.Traveler_Information_Q2',
          answer: 'Faqs.Traveler_Information_A2',
        },
        {
          question: 'Faqs.Traveler_Information_Q3',
          answer: 'Faqs.Traveler_Information_A3',
        },
        {
          question: 'Faqs.Traveler_Information_Q4',
          answer: 'Faqs.Traveler_Information_A4',
        },
      ],
    },
  ];

  navigateContact() {
    this.router.navigate(['/contact-us']);
  }

  setActiveTab(tabId: string) {
    this.activeTab.set(tabId);
  }

  toggleFaq(faq: FAQItem) {
    faq.isOpen = !faq.isOpen;
  }
}
